var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export var INSURERS = [
    'AOK Baden-Württemberg',
    'AOK Bayern',
    'AOK Bremen/Bremerhaven',
    'AOK Hessen',
    'AOK Niedersachsen',
    'AOK Nordost',
    'AOK Nordwest',
    'AOK PLUS',
    'AOK Rheinland-Pfalz/Saarland',
    'AOK Rheinland/Hamburg',
    'AOK Sachsen-Anhalt',
    'Audi BKK',
    'BAHN-BKK',
    'BARMER',
    'BERGISCHE Krankenkasse',
    'Bertelsmann BKK',
    'BIG Direkt Gesund',
    'BKK Aesculap',
    'BKK Akzo Nobel Bayern',
    'BKK B. Braun Aesculap',
    'BKK Deutsche Bank AG',
    'BKK Diakonie',
    'BKK DürkoppAdler',
    'BKK EUREGIO',
    'BKK evm',
    'BKK EWE',
    'BKK exklusiv',
    'BKK Faber-Castell & Partner',
    'BKK firmus',
    'BKK Freudenberg',
    'BKK Gildemeister Seidensticker',
    'BKK Groz-Beckert',
    'BKK HERKULES',
    'BKK KARL MAYER',
    'BKK Linde',
    'BKK MAHLE',
    'BKK Melitta HMR',
    'BKK Merck',
    'BKK Miele',
    'BKK MTU',
    'BKK PFAFF',
    'BKK Pfalz',
    'BKK ProVita',
    'BKK Public',
    'BKK PwC',
    'BKK Rieker.Ricosta.Weisser',
    'BKK Salzgitter',
    'BKK SBH',
    'BKK Scheufelen',
    'BKK Technoform',
    'BKK Textilgruppe Hof',
    'BKK VBU',
    'BKK VDN',
    'BKK VerbundPlus',
    'BKK Voralb HELLER*INDEX*LEUZE',
    'BKK Werra-Meissner',
    'BKK WIRTSCHAFT & FINANZEN',
    'BKK Würth',
    'BKK ZF & Partner',
    'BKK24',
    'BMW BKK',
    'Bosch BKK',
    'Continentale BKK',
    'Mercedes-Benz BKK',
    'DAK Gesundheit',
    'Debeka BKK',
    'Energie-BKK',
    'Ernst & Young BKK',
    'Heimat Krankenkasse',
    'HEK - Hanseatische Krankenkasse',
    'HKK Krankenkasse',
    'IKK - Die Innovationskasse',
    'IKK Brandenburg und Berlin',
    'IKK Classic',
    'IKK Gesund Plus',
    'IKK Südwest',
    'KKH Kaufmännische Krankenkasse',
    'KNAPPSCHAFT',
    'Koenig & Bauer BKK',
    'Krones BKK',
    'Sozialversicherung für Landwirtschaft, Forsten und Gartenbau - SVLFG',
    'Mhplus BKK',
    'BKK Mobil',
    'Novitas BKK',
    'Pronova BKK',
    'R+V Betriebskrankenkasse',
    'Salus BKK',
    'SBK',
    'SECURVITA Krankenkasse',
    'SKD BKK',
    'Südzucker-BKK',
    'Techniker Krankenkasse (TK)',
    'TUI BKK',
    'VIACTIV Krankenkasse',
    'Vivida BKK',
    'WMF BKK',
];
var assertedInsurers = __spreadArrays(INSURERS);
